import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import settings from '../../utils/settings';
import useActivationPostMessage from '../../hooks/useActivationPostMessage';
import { getToken } from '../../utils/helper';
import getConfig from '../../config/env';

const ActivationBreadcrumb = () => {
  const activationBaseUrl = settings.activationUrl();
  const [dataFromActivationUI, setDataFromActivationUI] = useState('');
  const [siteID, setSiteId] = useState('');
  const [dynamicstyle, setDynamicStyle] = useState({ height: '100%' });
  const iframe_breadcrumb_activation = useRef();
  const token = getToken();
  const { source_id } = useParams();
  const allowedOrigin = getConfig()['activation_url'];
  const navigationType = performance?.getEntriesByType("navigation")?.length && performance?.getEntriesByType("navigation")[0]?.type ;

  useEffect(() => {
    if (source_id && !isNaN(Number(source_id))) {
      setSiteId(source_id);
    }
  }, [source_id]);
  useEffect(() => {
    const url = new URL(allowedOrigin)
    window.addEventListener('message', e => {
      if (url && url.origin !== e.origin && window.location.origin !== e.origin) {
        return;
      }
      if (e.data?.breadCrumbScrollHeight) {
        setDynamicStyle({ ...dynamicstyle, height: `${e.data.breadCrumbScrollHeight}px` })
      }
    });
    return () => {
      window.removeEventListener('message', null);
    };
  }, []);
  useActivationPostMessage(
    dataFromActivationUI,
    activationBaseUrl,
    iframe_breadcrumb_activation,
    setDataFromActivationUI
  );

  return (
    <div><iframe
        title='breadCrumb'
        ref={iframe_breadcrumb_activation}
        style={{ border: 'none', width: '100%', ...dynamicstyle }}
        src={`${activationBaseUrl}/?pane=breadcrumb&siteid=${siteID}&navigationtype=${navigationType}`}
      />
    </div>
  );
};
export default ActivationBreadcrumb;